if (!customElements.get('pdp-sticky-atc')) {
  customElements.define(
    'pdp-sticky-atc',
    class PdpStickyAtc extends HTMLElement {
      connectedCallback() {
        if (!this.initialize()) requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (this.initialized) return true;

        this.originalButton = document.getElementById(this.dataset.submitButtonId);
        this.stickyButton = this.querySelector('.pdp-sticky-atc__button');
        if (!this.originalButton || !this.stickyButton) return false;
        this.initialized = true;

        this.stickyButton.addEventListener('click', () => this.originalButton.click());
        this.syncButtonState();

        this.buttonObserver = new MutationObserver(() => this.syncButtonState());
        this.buttonObserver.observe(this.originalButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          childList: true,
          subtree: true,
        });

        this.updateVisibility = () => {
          if (this.visibilityFrame) return;
          this.visibilityFrame = requestAnimationFrame(() => {
            this.classList.toggle('is-visible', this.originalButton.getBoundingClientRect().bottom < 0);
            this.visibilityFrame = null;
          });
        };
        window.addEventListener('scroll', this.updateVisibility, { passive: true });
        window.addEventListener('resize', this.updateVisibility);
        this.updateVisibility();

        this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.dataset.sectionId) return;

          const sourcePrice = data.html.getElementById(`price-${data.sectionId}`)?.querySelector('.price');
          const stickyPrice = this.querySelector('.pdp-sticky-atc__price');
          if (sourcePrice && stickyPrice) stickyPrice.innerHTML = sourcePrice.outerHTML;

          const image = this.querySelector('.pdp-sticky-atc__image');
          const nextImage = data.variant?.featured_media?.preview_image;
          if (image && nextImage?.src) image.src = nextImage.src;

          requestAnimationFrame(() => {
            this.originalButton = document.getElementById(this.dataset.submitButtonId);
            this.syncButtonState();
          });
        });

        return true;
      }

      disconnectedCallback() {
        this.buttonObserver?.disconnect();
        window.removeEventListener('scroll', this.updateVisibility);
        window.removeEventListener('resize', this.updateVisibility);
        if (this.visibilityFrame) cancelAnimationFrame(this.visibilityFrame);
        this.variantUnsubscriber?.();
      }

      syncButtonState() {
        if (!this.originalButton || !this.stickyButton) return;

        const isDisabled =
          this.originalButton.disabled || this.originalButton.getAttribute('aria-disabled') === 'true';
        const isLoading = this.originalButton.classList.contains('loading');
        const label = this.originalButton.querySelector('span')?.textContent?.trim();

        this.stickyButton.disabled = isDisabled;
        this.stickyButton.classList.toggle('loading', isLoading);
        if (label) this.stickyButton.querySelector('span').textContent = label;
      }
    }
  );
}
